module.exports = __webpack_public_path__ + "img/img3015.ce57ff90.jpg";